import { FC } from 'react';
import useTranslation from '../../../../features/translation/hooks/useTranslation';
import './PropertiesContainer.scss';

type Property = {
  id: string;
  type: string;
};

interface Props {
  speed: number;
  thread: Property;
  lengthAtEnd: number;
}

enum TranslationKeys {
  MAX_SPEED = 'maxSpeed',
  THREAD = 'thread',
  LENGTH_AT_END_POSITION = 'lengthAtEndPosition',
}

const PropertiesContainer: FC<Props> = ({ lengthAtEnd, speed, thread }) => {
  const t = useTranslation();

  const maxSpeedProperty = {
    icon: false,
    valueSuffix: 'm/s',
  };

  const threadProperty = {
    icon: false,
    valueSuffix: '',
  };

  const lengthProperty = {
    icon: false,
    valueSuffix: 'mm',
  };
  return (
    <div className="ems-properties-container">
      <div key={t(TranslationKeys.MAX_SPEED)} className="ems-description">
        <p className="ems-description-key fwe-pt-2">{t(TranslationKeys.MAX_SPEED)}</p>{' '}
        <p className="fwe-pt-1 ems-description-value--highlight">
          {maxSpeedProperty.icon && <i className={`fwe-icon fwe-icon-${maxSpeedProperty.icon} fwe-mr-2`} />}
          {speed} {maxSpeedProperty.valueSuffix}
        </p>
      </div>
      <div key={t(TranslationKeys.THREAD)} className="ems-description">
        <p className="ems-description-key fwe-pt-2">{t(TranslationKeys.THREAD)}</p>{' '}
        <p className="fwe-pt-1 ems-description-value--highlight">
          {threadProperty.icon && <i className={`fwe-icon fwe-icon-${threadProperty.icon} fwe-mr-2`} />}
          {thread.type} {threadProperty.valueSuffix}
        </p>
      </div>
      <div key={t(TranslationKeys.LENGTH_AT_END_POSITION)} className="ems-description">
        <p className="ems-description-key fwe-pt-2 ems-description--long-sentence">
          {t(TranslationKeys.LENGTH_AT_END_POSITION)}
        </p>{' '}
        <p className="fwe-pt-1 ems-description-value--highlight">
          {lengthProperty.icon && <i className={`fwe-icon fwe-icon-${lengthProperty.icon} fwe-mr-2`} />}
          {lengthAtEnd} {lengthProperty.valueSuffix}
        </p>
      </div>
    </div>
  );
};

export default PropertiesContainer;
